<template>
    <div class="agency-map">
        <h2 class="agency-map-title">
            {{ trans('labels.calculate_route') }}
        </h2>

        <div class="agency-map-container">
            <div class="search-and-map col-lg-12 p-0">
                <div class="search-bar-container">
                    <div
                        v-if="geolocalization"
                        class="geolocalize"
                        @click="geolocalize"
                    >
                        <img src="/img/icons/map/gps.svg" alt="Geolocalization" />
                    </div>

                    <address-autocomplete
                        :is-home="false"
                        @input="routeTo"
                    />

                    <div class="buttons">
                        <label for="car">
                            <img :src="'/img/icons/map/car-' + (current_type == 'driving' ? 'on' : 'off' ) + '.svg'" class="ico_percorso">
                            <input type="radio" name="car" id="car" v-model="current_type" value="driving" @change="setType">
                        </label>
                        <label for="man">
                            <img :src="'/img/icons/map/man-' + (current_type !== 'driving' ? 'on' : 'off' ) + '.svg'" class="ico_percorso">
                            <input type="radio" name="man" id="man" v-model="current_type" value="walking" @change="setType">
                        </label>
                    </div>
                </div>

                <tecno-map
                    ref="map"
                    :options="options"
                    :sector="sector"
                    class="detail-map"
                />
            </div>
        </div>
        <div
            class="actions-container col-lg-12"
            ref="actions_container"
            id="actions_container"
            v-if="last_result.actions && last_result.actions.length"
        >
            <div class="info-street">
                <div class="label">{{ trans('labels.route_directions') }}</div>
                <div class="actions-buttons" v-if="last_result.actions && last_result.actions.length">
                    <button class="btn" @click="copy">
                        <img src="/img/icons/copy-agency.svg">{{ lang.labels.copy }}
                    </button>

                    <button class="btn" @click="print">
                        <img src="/img/icons/print-agency.svg"> {{ lang.labels.print }}
                    </button>
                </div>
            </div>
            <p
                v-for="(action,index) in last_result.actions"
                :key="index"
            >
                <strong>{{ (index + 1) }} .</strong> {{action}}
            </p>
        </div>
    </div>
</template>

<script>
import TecnoMap from '../maps/Map'
import { networkColor } from '../../helpers/colors'
import AddressAutocomplete from '../AddressAutocomplete'
import VueClipboard from 'vue-clipboard2'
import VueHtmlToPaper from 'vue-html-to-paper'

const options = {
    name: '_blank',

    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],

    styles: [
        './css/app.css'
    ]
}

Vue.use(VueHtmlToPaper, options)
Vue.use(VueClipboard)

export default {
    props: {
        latitude: {
            type: Number,
            required: true,
        },

        longitude: {
            type: Number,
            required: true,
        },

        marker: {
            type: [String,Boolean],
            required: false,
            default: false,
        },

        network: {
            type: String,
            default: 'tec',
        },

        poi: {
            type: Array,
            default() {
                return ['public_transport', 'school', 'pharmacy', 'bank', 'post', 'market', 'parking']
            },
        },

        sector: {
            type: String,
        },

        type: {
            type: String,
            default: 'driving',
        },
    },

    data() {
        return {
            options: {
                minZoom: 6,
                maxZoom: 18,
                currentZoom: 15,
                style: '/core/v1/' + this.$root.country_full_name + '/style.json',

                mapCenter: {
                    coords: [this.longitude, this.latitude],
                    marker: {
                        image: this.marker,
                        focus: true // la mappa si sposta sul punto
                    }
                },

                features: {
                    uriCoords: false,
                    scrollZoom: false,
                    dragRotate: false,
                    touchZoomRotate: true
                },

                modules: {
                    navigationControl: {
                        uiPosition: 'bottom-left',
                        zoom: true,
                    },
                    poi: {
                        country: this.$root.country_full_name,
                        endpoint: window.tecnomapsEndpoint + '/v2/services/poi',
                        fixed: this.poi,
                    }
                }
            },
            current_type: this.type,
            last_result: {},
            last_search: [],
            geolocalization: false,
        }
    },

    created() {
        // console.log('Portale/Maps/AgencyMap - created')
    },

    mounted() {
        // console.log('Portale/Maps/AgencyMap - mounted')
        if ("geolocation" in navigator) {
            this.geolocalization = true
        }
    },

    beforeDestroy() {
        // console.log('Portale/Maps/AgencyMap - beforeDestroy')
    },

    components: {
        'tecno-map': TecnoMap,
         'address-autocomplete': AddressAutocomplete,
    },

    computed: {
        lang() {
            return this.$root.lang.agency_card
        },

        mapContainerClass() {
            return this.last_result.actions && this.last_result.actions.length ? 'col-lg-6' : 'col-lg-12'
        },

        actionsString() {
            return this.last_result.actions ? this.last_result.actions.reduce((accumulator, action, index) => accumulator + (index + 1) + '. ' + action + '\n', '') : ''
        }
    },

    methods: {
        copy() {
            let container = this.$refs.actions_container
            this.$copyText(this.actionsString, container)

            flash(this.lang.flash.copied)
        },

        print() {
            this.$htmlToPaper('actions_container')
        },

        setType(event) {
            this.current_type = event.target.value
            if (this.last_search.length > 0) {
                this.calculate(this.last_search)
            }
        },

        geolocalize() {
            navigator.geolocation.getCurrentPosition((position) => {
                let coords = {
                    longitude: position.coords.longitude,
                    latitude: position.coords.latitude,
                }
                this.calculate(coords)

            })
        },

        routeTo(event) {
            this.calculate(event.position)
        },

        calculate(coordinates) {
            if (coordinates !== this.last_search) this.last_search = coordinates
            // isLoading()
            axios.get(window.tecnomapsEndpoint + '/services/transit-route/v1/calculate', {
                params: {
                    language: window.country,
                    destination: this.latitude + ',' + this.longitude,
                    origin: coordinates.latitude + ',' + coordinates.longitude,
                    transport: this.current_type
                }
            })
            .then(({data}) => {
                // stopLoading()
                this.last_result = data['details']
                window.dispatchEvent(
                    new CustomEvent('tecnomap.interactions.displayRoute', {
                        detail: {
                            id: this.$refs.map.id,
                            polyline: this.last_result.polyline,
                            options: {
                                bounds: true,
                                offset: 100,
                                color: networkColor(this.network),
                            }
                        }
                    })
                )
                window.dispatchEvent(
                    new CustomEvent('tecnomap.interactions.addMarkers', {
                        detail: {
                            id: this.$refs.map.id,
                            markers: [
                                {
                                    coords: {
                                        lat: this.latitude,
                                        lng: this.longitude,
                                    },
                                    options: {
                                        image: this.marker,
                                    }
                                },
                                {
                                    coords: {
                                        lat: coordinates.latitude,
                                        lng: coordinates.longitude,
                                    },
                                    options: {
                                        color: networkColor(this.network),
                                    }
                                },
                            ],
                        }
                    })
                )
            })
        },
    }
}
</script>
